import * as React from "react";
import { CollectFunnelContext } from "components/collectFunnel/CollectFunnelProvider";
import { SET_PRODUCTS } from "components/collectFunnel/constants";

import { CollectProductDetails } from "components/collect/CollectProductDetails";
import { MURFY_BOUGHT, MURFY_REPAIRED, IS_BROKEN } from "components/collectFunnel/constants";
import { Box, Typography } from "@material-ui/core";
import { scrollToRef } from "components/utils";
import { STEP_DATE_URL } from "components/collectFunnel/constants";
import { useRouter } from "next/router";

export const CollectFunnelProductsInformationsStep = ({ handleNextStep }) => {
  const [state, dispatch] = React.useContext(CollectFunnelContext);
  const [productIndex, setProductIndex] = React.useState(0);
  const beginFormRef = React.useRef();
  const router = useRouter();

  const pushToDateStep = React.useCallback(() => {
    router.push(STEP_DATE_URL, undefined, { shallow: true });
  }, [router]);

  const goToPreviousProduct = () => {
    if (productIndex > 0) setProductIndex(productIndex - 1);
    else pushToDateStep();
  };

  const nextStep = () => {
    if (productIndex < state.products.length - 1) {
      setProductIndex(productIndex + 1);
      scrollToRef(beginFormRef);
    } else {
      setProductIndex(0);
      handleNextStep();
    }
  };

  const dispatchProducts = (stateProducts) => {
    dispatch({
      type: SET_PRODUCTS,
      data: { products: stateProducts },
    });
  };

  const saveAnswer = (answer) => {
    let stateProducts = state.products;
    if (answer.question === MURFY_BOUGHT) {
      stateProducts[productIndex][MURFY_BOUGHT] = answer;
    } else if (answer.question === MURFY_REPAIRED) {
      stateProducts[productIndex][MURFY_REPAIRED] = answer;
    } else if (answer.question === IS_BROKEN) {
      stateProducts[productIndex][IS_BROKEN] = answer;
    }
    dispatchProducts(stateProducts);
  };

  const setBrand = (value) => {
    let stateProducts = state.products;
    stateProducts[productIndex]["brand"] = value;
    dispatchProducts(stateProducts);
  };

  const setProblem = (value) => {
    let stateProducts = state.products;
    stateProducts[productIndex]["problem"] = value;
    dispatchProducts(stateProducts);
  };

  return (
    <>
      <Box py={3} ref={beginFormRef}>
        <Typography color="secondary" variant={"h2"}>{`Nous avons besoin de quelques informations sur ${
          state.products.length > 1 ? "vos" : "votre"
        } appareil${state.products.length > 1 ? "s" : ""} :`}</Typography>
      </Box>
      <CollectProductDetails
        buttonText="Continuer"
        handleNextStep={nextStep}
        handlePreviousStep={goToPreviousProduct}
        saveAnswer={saveAnswer}
        onChangeBrand={setBrand}
        onChangeProblem={setProblem}
        murfyRepaired={state.products[productIndex][MURFY_REPAIRED]}
        murfyBought={state.products[productIndex][MURFY_BOUGHT]}
        productIndex={productIndex}
        brand={state.products[productIndex]["brand"]}
        productsToCollect={state.products}
        isBroken={state.products[productIndex][IS_BROKEN]}
        problem={state.products[productIndex]["problem"]}
      />
    </>
  );
};
